import { render, staticRenderFns } from "./VulnTable.vue?vue&type=template&id=863fc494"
import script from "./VulnTable.vue?vue&type=script&lang=js"
export * from "./VulnTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports